import { $api } from "../generated/client";

export function useSearchProducts(
  shopId: string,
  q: string,
  options?: { enabled?: boolean },
) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/products",
    {
      params: {
        path: { shopId },
        query: q ? { q } : {},
      },
    },
    {
      // `enabled` belongs in this options argument: openapi-react-query only
      // forwards the third argument to the fetch and the query key, so passing
      // it there left the query firing on every render.
      enabled: options?.enabled ?? true,
      // The search now hits Shopify. A 4xx says the request itself is wrong and
      // retrying only keeps the merchant in front of a spinner.
      retry: (failureCount: number, error: unknown) => {
        const status = (error as { statusCode?: number } | null)?.statusCode;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  );
}
